<template>
	<section class="inline-button-group font-gilroy font-16 cursor-pointer">
		<button @click="$emit('matchClicked','all')"
			:class="[match_button_all_active]" class="margin-n4 match-button-size match-text-color match-button-border border-right-reset">
			Match All
		</button>
		<button  @click="$emit('matchClicked','any')"
		:class="[match_button_any_active]"  class="match-button-size match-text-color match-button-border border-left-reset">
			Match Any
		</button>
	</section>
</template>
<script>
export default {
	props:{
		match_all:{
			type: String
		}
	},
	computed: {
		match_button_background(){
			return 'background-white'
		},
		match_button_all_active(){
			return this.match_all == 'AND' ? 'background-green text-green' : 'background-white'
		},
		match_button_any_active(){
			return this.match_all == 'OR' ? 'background-green text-green' : 'background-white'
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/components/automation/automationSharedView/matchButtonGroup.vue